import { createTheme, styled } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#3743aa",
            light: "#6e6edc",
            dark: "#001c7a",
            contrastText: "#ffffff",
        },
        secondary: {
            main: '#3743aa',
            light: '#6e6edc',
            dark: '#001c7a',
            contrastText: '#ffffff',
        },
        // secondary: {
        //     main: "#00e676",
        //     light: "#66ffa6",
        //     dark: "#00b248",
        //     contrastText: "#3743aa",
        // },
        // error: {
        //     main: "#E23636",
        // },
        success: {
            main: "#32cc25",
        },
    },
    typography: {
        h6: {
            fontSize: "1.5em",
        },
    },
    components: {
        MuiTypography: {
            defaultProps: {
                fontFamily: "Muli, sans-serif !important",
                // fontSize: "1.2vw",
            },
        },
        MuiButton: {
            defaultProps: {
                style: {
                    fontFamily: "Muli, sans-serif",
                    fontWeight: "bold !important",
                    fontSize: "14px !important",
                    textTransform: "none",
                },
            },
        },
    },
});

export const customStylesDefault = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
        },
    },
    table: {
        style: {
            minHeight: "5rem !important",
            placeContent: "center",
            maxHeight: "800px !important",
            overflow: "auto",
        },
    },
    headRow: {
        style: {
            zIndex: "0 !important",
        },
    },
};

export const customStyles = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
        },
    },
    table: {
        style: {
            minHeight: "5rem !important",
            maxHeight: "400px !important",
            overflow: "auto",
            paddingRight: 0,
            "& .jiVSeR": {
                whiteSpace: "normal !important"
            },
            "& .gELLeU": {
                whiteSpace: "normal !important",
            }
        },
    },
    headRow: {
        style: {
            zIndex: "0 !important",
        },
    },
};

export const customStylesCompany = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
            paddingRight: 0,
        },
    },
    table: {
        style: {
            // maxHeight: '500px !important',
            minHeight: "5rem !important",
            placeContent: "center",
            overflow: "auto",
        },
    },
    headRow: {
        style: {
            zIndex: "0 !important",
        },
    },
};

export const customStyles2 = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
            paddingRight: 0,
            "& .jiVSeR": {
                whiteSpace: "normal !important"
            },
            "& .gELLeU": {
                whiteSpace: "normal !important",
            }
        },
    },
    pagination: {
        style: {
            "& select": {
                width: "40px",
                padding: "2px 10px",
            },
        },
    },
    table: {
        style: {
            minHeight: "5rem !important",
            placeContent: "center",
        },
    },
};

export const customStyles3 = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
            "& .jiVSeR": {
                whiteSpace: "normal !important"
            },
            "& .gELLeU": {
                whiteSpace: "normal !important",
            }
        },
    },
    table: {
        style: {
            maxHeight: "300px !important",
            overflow: "auto",
            minHeight: "5rem !important",
        },
    },
};

export const customStyles4 = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
            paddingRight: 16,
            "& .jiVSeR": {
                whiteSpace: "normal !important"
            },
            "& .gELLeU": {
                whiteSpace: "normal !important",
            }
        },
    },
    table: {
        style: {
            minHeight: "5rem !important",
            placeContent: "center",
        },
    },
};

export const customStyles5 = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
            paddingRight: 0,
        },
    },
    table: {
        style: {
            width: "96%",
            margin: "auto",
            overflow: "auto",
            minHeight: "5rem !important",
            placeContent: "center",
        },
    },
};

export const customStylesCrm = {
    headCells: {
        style: {
            color: "#969BA0",
            fontWeight: 600,
            paddingRight: 0,
            "& .jiVSeR": {
                whiteSpace: "normal !important"
            },
            "& .gELLeU": {
                whiteSpace: "normal !important",
            }
        },
    },
    pagination: {
        style: {
            "& select": {
                width: "40px",
                padding: "2px 10px",
            },
        },
    },
    table: {
        style: {
            minHeight: "5rem !important",
            placeContent: "center",
            "& div:first-child": {
                width: "-webkit-fill-available",
            }
        },
    },
};

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titleTable: {
            display: "flex",
            width: "100%",
        },
        buttonAdd: {
            marginLeft: "8% !important",
        },
        titleH2: {
            display: "flex",
            width: "82%",
        },
        iconTitle: {
            marginTop: "4px",
            marginRight: "5px",
        },
        label: {
            fontWeight: 400,
            fontFamily: "Muli,sans-serif",
            fontSize: "0.875rem",
        },
        selectOption: {
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
            marginTop: "12px",
        },
    })
);

export const iconStyle = makeStyles((theme) => ({
    icon1: {
        width: "2rem",
        height: "2.5rem",
        color: "white !important",
        backgroundColor: "#3743aa !important",
        borderRadius: "4px",
        padding: "4px",
    },
}));


export const SideBarStyle = styled("div")(() => ({
    "& .MuiTypography-root": {fontSize: "16px"}, 
    "& .MuiSvgIcon-root": {height: "10.5rem", width: "1.5rem", color: "#969ba0"}, 
    "& .MuiListItemIcon-root": {minWidth: "3rem"}, 
    background: "#fff", 
    borderLeft: "1px solid #edf0f4",  
    "& .MuiButtonBase-root":{p: "0.6rem 1.4rem"}, 
    color: "#969ba0" 
}));


export const ContentStyle = styled("div")(() => ({
    '& .css-nz481w-MuiInputBase-input-MuiInput-input, .css-7dqvty-MuiInputBase-input': {border: 'none !important', fontFamily: "Muli, sans-serif !important", padding: 0, fontSize: "16px !important"},
    '& .MuiInput-underline:after, .MuiInput-underline:before, .MuiInput-underline:hover': {borderBottomColor: 'white !important'},
    "& .css-1rxz5jq-MuiSelect-select-MuiInputBase-input-MuiInput-input:focus": {backgroundColor: "#fff"}, 
    alignContent: "center",
}));


  